import { getRequest, postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';
import { userRequestQueryParam } from '../util/helpers/userRequestHelper';

export const createUserRequest = (payload) => {
  const {
    Email,
    Password,
    TrackingDetails,
    RecaptchaToken,
    accountType,
    applicationType,
    registrationFlowType,
    accountUid,
    accountCode,
    userUid,
    brokerCode,
    logonUid,
    username,
    isUpgrade,
  } = payload;
  const requestPayload = isUpgrade
    ? { TrackingDetails, Email }
    : {
        Email,
        Password,
        RecaptchaToken,
        TrackingDetails,
      };

  const queryParamsBase = userUid
    ? userRequestQueryParam(
        applicationType,
        accountType,
        registrationFlowType,
        brokerCode,
        logonUid,
        username,
        userUid,
      )
    : userRequestQueryParam(
        applicationType,
        accountType,
        registrationFlowType,
        brokerCode,
        logonUid,
        username,
      );
  const queryParams = isUpgrade
    ? {
        ...queryParamsBase,
        accountUid,
        accountCode,
        isFromDashboard: true,
      }
    : { ...queryParamsBase };

  return postRequest(
    apiEndpoints.users.createUser,
    requestPayload,
    queryParams,
  );
};

export const authenticateUserRequest = (payload) =>
  postRequest(apiEndpoints.users.authenticateUser, payload);

export const refreshTokensRequest = ({ data }) =>
  postRequest(apiEndpoints.users.refresh, data);

export const postForgottenPasswordRequest = (payload) => {
  const { Username } = payload;
  const queryParams = { username: Username };

  return postRequest(
    apiEndpoints.users.confirmForgotPassword,
    Username,
    queryParams,
  );
};

export const postResetPasswordRequest = (data) =>
  postRequest(apiEndpoints.users.resetPassword, data);

export const generateTokenRequest = (payload) =>
  postRequest(apiEndpoints.users.generateToken, payload);

export const getBasicAccountRequest = ({ applicationUid, accountUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.users.getBasicAccount, {
      applicationUid,
      accountUid,
    }),
  );

export const getUsernames = ({ email, token }) =>
  getRequest(apiEndpoints.users.getUsernames, {
    email,
    recaptchaToken: token,
  });

export const createPlainUserRequest = (payload) =>
  postRequest(apiEndpoints.users.plainUser, payload);

export const encryptEmailRequest = (data) =>
  getRequest(replaceInUrl(apiEndpoints.users.getEncryptedEmail), data);

export const decryptEmailRequest = (data) =>
  getRequest(replaceInUrl(apiEndpoints.users.getDecryptedEmail), data);
